import type { FC } from 'react'
import { useLabelFormContext } from '../LabelFormContext'
import { BBoxOverlay } from './BBoxOverlay'
import { ReUploadButton } from './ReUploadButton'

/**
 * ラベルの画像と設定済みの検査箇所を表示する
 * 画像や検査箇所をクリックしたときに編集モードに遷移する
 */
export const LabelImagePreview: FC = () => {
  const {
    formValues: { imageUrl, areas, calibrationAreas },
    setEditingTarget,
    setValue,
  } = useLabelFormContext()

  return (
    <>
      <BBoxOverlay
        imageUrl={imageUrl}
        areas={areas}
        calibrationAreas={calibrationAreas}
        onClickArea={area => setEditingTarget({ type: 'area-edit', area })}
        onClickImage={() => setEditingTarget({ type: 'area-new' })}
      />
      <ReUploadButton setValue={setValue} />
    </>
  )
}
